var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoligon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M5.5,0,11,10H0Z",
    transform: "translate(0 11) rotate(-90)",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoligon);
export default __webpack_public_path__ + "static/media/poligon.335f2bb87ed1401e8a64aef44285c8e9.svg";
export { ForwardRef as ReactComponent };